export const USER_AND_ENTRY_TYPES = {
  PROMOTOR: "PROMOTOR",
  SUB_PROMOTOR: "SUB_PROMOTOR",
  "WALK UP": "WALK UP",
  STAFF: "STAFF",
  TOTAL: "TOTAL",
};
